module.exports = __webpack_public_path__ + "static/OscarCircle-0bcd0a3216bd138411e8babd534655d8.png";